import {Button, Popover} from "@mui/material";
import * as React from "react";
import {useState} from "react";
import SearchPopoverProps from "@/src/_types/search-popover-props";
import SearchContainer
    from "@/src/components/main-site/_partials/header/search/mui-custom/search-container/search-container";
import SearchInput from "@/src/components/main-site/_partials/header/search/mui-custom/search-input/search-input";
import SearchIconWrapper
    from "@/src/components/main-site/_partials/header/search/mui-custom/search-icon-wrapper/search-icon-wrapper";
import {faMagnifyingGlass} from "@fortawesome/pro-duotone-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const SearchPopover: React.FC<SearchPopoverProps> = ({elAnchor, setElAnchor}) => {
    const [searchTerm, setSearchTerm] = useState<string>('');
    return (
        <Popover
            id="popover-search"
            aria-labelledby="search-button"
            anchorEl={elAnchor}
            open={elAnchor != null}
            onClose={() => setElAnchor(null)}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}
        >
            <SearchContainer>
                <SearchIconWrapper>
                    <FontAwesomeIcon icon={faMagnifyingGlass}/>
                </SearchIconWrapper>
                <SearchInput
                    value={searchTerm}
                    onChange={(event) => setSearchTerm(event.target.value)}
                    placeholder="Search..."
                    size="small"
                />
                <Button
                    onClick={() => alert(`Searching for: ${searchTerm}`)}
                    variant="contained"
                    color="primary"
                >
                    Search
                </Button>
            </SearchContainer>
        </Popover>
    )
}

export default SearchPopover;
